import { motion } from 'framer-motion'

import { styled } from 'styled-system/jsx'

const PageContainer = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background:
      'linear-gradient(135deg, {colors.quickpass.surfaceCool} 0%, {colors.quickpass.surface} 60%, #FEF0FF 100%)',
    padding: '24px',
  },
})

const ContentCard = styled(motion.div, {
  base: {
    width: '100%',
    maxWidth: '440px',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    boxShadow: '0 24px 60px -20px rgba(128, 84, 255, 0.18)',
    padding: '36px 32px 32px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
})

const Wordmark = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '24px',
    fontWeight: '800',
    letterSpacing: '-0.5px',
    color: 'quickpass.primary',
    margin: '0',
    textAlign: 'center',
  },
})

const Heading = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '32px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '4px 0 0 0',
    textAlign: 'center',
    letterSpacing: '-0.5px',
  },
})

const Subheading = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    color: 'quickpass.inkSoft',
    margin: '0',
    textAlign: 'center',
  },
})

const WidgetContainer = styled('div', {
  base: {
    width: '100%',
    marginTop: '20px',
  },
})

const ErrorMessage = styled(motion.div, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.warmth',
    padding: '10px 14px',
    borderRadius: 'sm',
    marginTop: '8px',
  },
})

const DevBypassDivider = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginTop: '20px',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '600',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.inkSoft',
    _before: {
      content: '""',
      flex: '1',
      height: '1px',
      backgroundColor: '#E5E0F5',
    },
    _after: {
      content: '""',
      flex: '1',
      height: '1px',
      backgroundColor: '#E5E0F5',
    },
  },
})

const DevBypassButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: '1.5px dashed',
    borderColor: '#D8D2EC',
    borderRadius: 'pill',
    paddingX: '16px',
    paddingY: '10px',
    cursor: 'pointer',
    marginTop: '4px',
    transition:
      'border-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      borderColor: 'quickpass.primary',
      color: 'quickpass.primary',
      backgroundColor: 'quickpass.surfaceCool',
    },
  },
})

const DevBypassHint = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'quickpass.inkSoft',
    margin: '6px 0 0 0',
    textAlign: 'center',
    fontStyle: 'italic',
  },
})

export {
  PageContainer,
  ContentCard,
  Wordmark,
  Heading,
  Subheading,
  WidgetContainer,
  ErrorMessage,
  DevBypassDivider,
  DevBypassButton,
  DevBypassHint,
}
